(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["1buckle-assistant"] && !Shopify.designMode) return;
  try {
    (()=>{
 const root=document.getElementById('buckle-assistant');if(!root)return;
 const dialog=root.querySelector('dialog'),launch=root.querySelector('.bap-launch'),log=root.querySelector('.bap-conversation'),chat=root.querySelector('.bap-chat'),status=root.querySelector('.bap-status'),question=root.querySelector('#bap-question');
 let messages=[],pending=false;
 const controls=[...root.querySelectorAll('[data-answer]'),...chat.querySelectorAll('button'),root.querySelector('.bap-reset')];
 function busy(v){pending=v;refreshVoiceControls();}
 function bubble(text,user){
  const p=document.createElement('p');p.className=user?'bap-question':'bap-reply';
  if(user)p.textContent=text;else appendLinks(p,text);
  log.append(p);p.scrollIntoView({block:'nearest'});
 }
 function appendLinks(p,text){
  const re=new RegExp('https://1buckle\\.com/[^\\s<>"\'\\)\\]]+','g');
  let last=0;
  for(const m of text.matchAll(re)){
   const url=m[0].replace(/[.,;:!?]+$/,'');
   p.append(document.createTextNode(text.slice(last,m.index)));
   const a=document.createElement('a');a.href=url;a.target='_blank';a.rel='noopener noreferrer';a.textContent=url;p.append(a);
   last=m.index+url.length;
  }
  p.append(document.createTextNode(text.slice(last)));
 }
 launch.addEventListener('click',()=>dialog.showModal());root.querySelector('.bap-close').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>{cancelVoice();launch.focus();});
 function resizeQuestion(){question.style.height='auto';question.style.height=Math.min(160,Math.max(68,question.scrollHeight+2))+'px';question.scrollTop=question.scrollHeight;}
 question.addEventListener('input',resizeQuestion);
 const mic=root.querySelector('.bap-mic'),voiceStatus=root.querySelector('.bap-voice-status');
 const Speech=window.SpeechRecognition||window.webkitSpeechRecognition;
 let recognition=null,voiceTimer=null,endTimer=null;
 function refreshVoiceControls(){controls.forEach(b=>{b.disabled=b===mic?pending||!Speech:pending||!!recognition;});question.readOnly=!!recognition;}
 function cancelVoice(){if(recognition){const r=recognition;recognition=null;r.abort();}clearTimeout(voiceTimer);clearTimeout(endTimer);mic.setAttribute('aria-pressed','false');mic.setAttribute('aria-label',mic.dataset.start);refreshVoiceControls();}
 mic.addEventListener('click',()=>{
  if(pending||!Speech)return;
  if(recognition){recognition.stop();return;}
  const base=question.value.trim();let finalText='',heard=false,failed=false,truncated=false;
  const r=new Speech();recognition=r;r.lang='en-US';r.interimResults=true;r.continuous=true;r.maxAlternatives=1;
  const render=text=>{const all=[base,text.trim()].filter(Boolean).join(' ');truncated=all.length>1500;question.value=all.slice(0,1500);resizeQuestion();};
  const finish=()=>{if(recognition!==r)return;render(finalText);recognition=null;clearTimeout(voiceTimer);clearTimeout(endTimer);mic.setAttribute('aria-pressed','false');mic.setAttribute('aria-label',mic.dataset.start);refreshVoiceControls();if(!failed)voiceStatus.textContent=mic.dataset[truncated?'truncated':heard?'review':'empty'];};
  r.onstart=()=>{if(recognition!==r)return;voiceStatus.textContent=mic.dataset.listening;};
  r.onresult=e=>{if(recognition!==r)return;let interim='';finalText='';for(let i=0;i<e.results.length;i++){const part=e.results[i][0].transcript;if(e.results[i].isFinal)finalText+=part+' ';else interim+=part+' ';}heard=!!finalText.trim();render(finalText+interim);};
  r.onerror=e=>{if(recognition!==r)return;failed=true;voiceStatus.textContent=mic.dataset[['not-allowed','service-not-allowed'].includes(e.error)?'denied':e.error==='no-speech'?'empty':'failed'];finish();try{r.abort();}catch(_){};};
  r.onend=finish;
  mic.setAttribute('aria-pressed','true');mic.setAttribute('aria-label',mic.dataset.stop);voiceStatus.textContent=mic.dataset.starting;refreshVoiceControls();
  try{r.start();voiceTimer=setTimeout(()=>{if(recognition===r){r.stop();endTimer=setTimeout(()=>{finish();try{r.abort();}catch(_){}},3000);}},60000);}catch(_){failed=true;voiceStatus.textContent=mic.dataset.failed;finish();}
 });
 document.addEventListener('visibilitychange',()=>{if(document.hidden)cancelVoice();});window.addEventListener('pagehide',cancelVoice);
 if(!Speech)voiceStatus.textContent=mic.dataset.unsupported;refreshVoiceControls();

 async function send(q){
  if(pending||recognition||!q)return;if(messages.length>=10){status.textContent=root.dataset.limit;return;}
  busy(true);bubble(q,true);question.value='';resizeQuestion();status.textContent=root.dataset.thinking;
  const next=[...messages,{role:'user',content:q}];
  const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),55000);
  try{
   const r=await fetch('https://1buckle.pythonanywhere.com/api/public/chat',{method:'POST',credentials:'omit',signal:controller.signal,headers:{'Content-Type':'application/json'},body:JSON.stringify({messages:next})});
   const d=await r.json();if(!r.ok)throw Error(d.error||root.dataset.error);
   bubble(d.answer,false);messages=[...next,{role:'assistant',content:d.answer}];status.textContent=d.needs_owner?root.dataset.owner:root.dataset.connected;
  }catch(err){status.textContent=(err.name==='AbortError'||err.message==='Failed to fetch')?root.dataset.error:err.message;}
  finally{clearTimeout(timer);busy(false);}
 }
 chat.addEventListener('submit',e=>{e.preventDefault();send(question.value.trim());});root.querySelectorAll('[data-answer]').forEach(b=>b.addEventListener('click',()=>send(b.textContent.trim())));
 root.querySelector('.bap-reset').addEventListener('click',()=>{if(pending)return;cancelVoice();messages=[];log.replaceChildren();status.textContent=root.dataset.connected;});
})();
  } catch(e) { console.error(e); }
})();

})();
